export const login = {
    contentLogin: 'Вы можете войти с помощью учетной записи APP AIS',
    downloadApp: 'Загрузить приложение AIS',
    downloadInstructions: 'Инструкции по загрузке',
    buttonLogin: 'Войти',
    passwordLabel: 'Пароль',
    title: 'Вход',
    forGetPassword: 'Забыли пароль?',
    register: 'Зарегистрироваться',
    noAccount: 'У вас еще нет аккаунта?',
};
